import {SupportedLocales} from '#types/locale.js';

export const homeLang = {
  [SupportedLocales.EN]: {
    audienceDiscovery: {
      title: 'Audience Discovery',
      subheader: "Audience suggestions tailored to your team's goals.",
      activatePrompt:
        "Receive audience suggestions customized for your team's goals. Updated every week with the power of Generative AI.",
      learnMore: 'Learn More',
      activate: 'Activate',
      marveAdminNote: 'Please contact your admin to enable Marve.',
      needRecentAudiencesPrompt:
        "Once you start creating audiences, you'll start receiving tailored audience suggestions every week right in this spot.",
      noRecommendationsBadge:
        "You do not have any audience recommendations at this time. We'll be generating more soon.",
      loadErrorMessage:
        'Could not load audience discovery. Try refreshing the page.',
      createAudience: 'Create Audience',
      createSuggestion: 'Create',
      openSuggestion: 'Open',
      datasetGroupTooltip: 'Dataset group connected to this suggestion.',
    },
    recentAudiences: {
      subheader:
        "Your team's most recent audiences. Use them for inspiration for your next campaign.",
      emptyMessage: "Looks like you don't have any recent audiences.",
      createAudience: 'Create Audience',
    },
  },
  [SupportedLocales.ES]: {
    audienceDiscovery: {
      title: 'Descubrimiento de audiencias',
      subheader:
        'Sugerencias de audiencia adaptadas a los objetivos de tu equipo.',
      activatePrompt:
        'Recibe sugerencias de audiencia personalizadas para los objetivos de tu equipo. Actualizadas cada semana con IA generativa.',
      learnMore: 'Más información',
      activate: 'Activar',
      marveAdminNote:
        'Ponte en contacto con tu administrador para habilitar Marve.',
      needRecentAudiencesPrompt:
        'Cuando empieces a crear audiencias, empezarás a recibir sugerencias personalizadas cada semana aquí.',
      noRecommendationsBadge:
        'No tienes recomendaciones de audiencia en este momento. Generaremos más pronto.',
      loadErrorMessage:
        'No se pudo cargar el descubrimiento de audiencias. Intenta actualizar la página.',
      createAudience: 'Crear audiencia',
      createSuggestion: 'Crear',
      openSuggestion: 'Abrir',
      datasetGroupTooltip:
        'Grupo de conjuntos de datos vinculado a esta sugerencia.',
    },
    recentAudiences: {
      subheader:
        'Las audiencias más recientes de tu equipo. Úsalas como inspiración para tu próxima campaña.',
      emptyMessage: 'Parece que no tienes ninguna audiencia reciente.',
      createAudience: 'Crear audiencia',
    },
  },
} as const;
